/**
 * Persisted `user_events.event_type` values from fruitful-all Prisma `EventType`
 * (`packages/database/schema.prisma`). Logged via `UserEventService.logEvent`
 * (member-app `POST /api/user/events` and backend call sites).
 *
 * Keep these string values in sync until the backend imports this package.
 */
export enum PersistedUserEvent {
    MOBILE_APP_LOGIN = 'MOBILE_APP_LOGIN',
    WEB_APP_LOGIN = 'WEB_APP_LOGIN',
    WEB_PLAID_EXCHANGE_LOGIN = 'WEB_PLAID_EXCHANGE_LOGIN',
    DISCLOSURE_ACKNOWLEDGMENT_INCOME_SPLIT = 'DISCLOSURE_ACKNOWLEDGMENT_INCOME_SPLIT',
    CARD_ACCOUNT_AUTOPAY_STATUS_CHANGE = 'CARD_ACCOUNT_AUTOPAY_STATUS_CHANGE',
    INCOME_SPLIT_STATUS_CHANGE = 'INCOME_SPLIT_STATUS_CHANGE',
    DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_OPENING_CASH = 'DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_OPENING_CASH',
    DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_OPENING_CARD = 'DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_OPENING_CARD',
    DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_JOINING_CASH = 'DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_JOINING_CASH',
    DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_JOINING_CARD = 'DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_JOINING_CARD',
    DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_OPENING_CASH_KYC = 'DISCLOSURE_ACKNOWLEDGEMENT_ACCOUNT_OPENING_CASH_KYC',
    DISCLOSURE_ACKNOWLEDGEMENT_INVESTMENT_MANAGEMENT_AGREEMENT = 'DISCLOSURE_ACKNOWLEDGEMENT_INVESTMENT_MANAGEMENT_AGREEMENT',
    SIGNUP_ONBOARDING_CONVERSION_EVENT_TRACKED = 'SIGNUP_ONBOARDING_CONVERSION_EVENT_TRACKED',
    SMS_CONSENT_OPT_IN = 'SMS_CONSENT_OPT_IN',
    DIRECT_DEPOSIT_ACCOUNT_VERIFICATION_LETTER_DOWNLOADED = 'DIRECT_DEPOSIT_ACCOUNT_VERIFICATION_LETTER_DOWNLOADED',
    BILL_PAY_ACCOUNT_VERIFICATION_LETTER_DOWNLOADED = 'BILL_PAY_ACCOUNT_VERIFICATION_LETTER_DOWNLOADED',
}

/** Request body for `POST /api/user/events`. */
export interface LogPersistedUserEventDto {
    eventType: PersistedUserEvent;
    metadata?: object;
}

/** Persisted user event as returned by `GET /api/user/events`. */
export interface PersistedUserEventRecord {
    eventType: PersistedUserEvent;
    metadata: object | null;
}

/** `metadata` shape logged with `PersistedUserEvent.SMS_CONSENT_OPT_IN`. */
export interface PersistedUserEventSmsConsentMetadata {
    phoneNumber: string;
    disclosureText: string;
    platform: string;
}
